import _ from "lodash";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import Reports from "../../common/reports/Reports";
import Autocomplete from "../../framework/Autocomplete";
import Button from "../../framework/Button";
import GlobalContext from "../../framework/GlobalContext";
import Shortcut from "../../framework/Shortcut";
import classes from "./index.module.css";
import TransportReportFilter from "./TransportReportFilter";
import TransportReportSummary from "./TransportReportSummary";
import AddTransport from "./addTransport";
import { displayToast } from "../../framework/toast/toastUtils";
import { saveTransport } from "../../services/transport-services";

const Transport = () => {
  const [showAddTransport, setShowAddTransport] = useState(false);
  const [transportData, setTransportData] = useState(null);
  const [onFilterShow, setOnFilterShow] = useState(false);
  const [onColumnShow, setOnColumnShow] = useState(false);
  const [rowLevelCTAs, setRowLevelCTAs] = useState([]);
  const [filterStates, setFilterStates] = useState(null);
  const [currentRowData, setCurrentRowData] = useState(null);

  const { setCurrentComponent, currentComponent } = useContext(GlobalContext);
  const reportRef = useRef();
  const editRef = useRef();
  const refreshRef = useRef();
  const lockRef = useRef();

  const refreshData = useCallback((filterData = {}) => {
    reportRef.current.applyFilters(filterData);
  }, []);

  const addTransport = useCallback((isEdit = false) => {
    if (isEdit) {
      setTransportData(reportRef.current.getCurrentRowData());
    }
    setShowAddTransport(true);
  }, []);

  const closeTransportAc = useCallback(() => {
    setShowAddTransport(false);
    setTransportData(null);
    setCurrentComponent("grid_reports");
    refreshRef.current.click();
  }, [setCurrentComponent]);


  const lockHandler = useCallback(async () => {
    if (!currentRowData) {
      console.error("No currentRowData available");
      return;
    }
    let saveTransportObject = {};
    saveTransportObject = {
      ...currentRowData.data,
      isLocked: !currentRowData?.data.isLocked,
    };
    const response = await saveTransport(saveTransportObject);
    if (response?.status === "success") {
      refreshData();
      displayToast({
        type: "success",
        title: saveTransportObject.isLocked
          ? "Locked Successfully"
          : "Unlocked Successfully",
      });
    }
  }, [currentRowData, refreshData]);

  const listener = useCallback(
    (e) => {
      const key = e.key?.toLowerCase();
      const ctrlKey = e.ctrlKey;
      const altKey = e.altKey;
      if (altKey && key === "r") {
        refreshRef.current.click();
        return;
      }
      if (ctrlKey && key === "e") {
        return editRef.current.click();
      }
      if (altKey && key === "l") {
        if (currentRowData?.data) lockRef.current.click();
        return;
      }
      if (altKey && key === "t") {
        return addTransport();
      }
    },
    [addTransport, currentRowData?.data]
  );

  useEffect(() => {
    const allRowCTAs = [
      <Button
        ref={editRef}
        startIcon={<Shortcut keys={["Ctrl", "E"]} />}
        label="Edit"
        onClick={() => {
          addTransport(true);
        }}
        isAccessible={currentRowData?true:false}
      />,
      <Button
        ref={lockRef}
        startIcon={<Shortcut keys={["Alt", "L"]} />}
        label={currentRowData?.data?.isLocked ? "Unlock" : "Lock"}
        onClick={() => {
          lockHandler();
        }}
        isAccessible={currentRowData}
      />,
    ];
    setRowLevelCTAs(allRowCTAs);
  }, [addTransport, currentRowData?.data.isLocked, lockHandler,currentRowData]);

  useEffect(() => {
    if (
      !onFilterShow &&
      !showAddTransport &&
      !onColumnShow &&
      currentComponent === "grid_reports"
    ) {
      document.addEventListener("keyup", listener, false);
    }
    return () => {
      document.removeEventListener("keyup", listener, false);
    };
  }, [
    currentComponent,
    listener,
    onColumnShow,
    onFilterShow,
    showAddTransport,
  ]);
  useEffect(() => {
    refreshData({ isFilterChanged: true, ...filterStates });
  }, [refreshData, filterStates]);
  return (
    <div className={classes["transport-report-container"]}>
      <Reports
        identifier="transport"
        reportRef={reportRef}
        rowLevelCTAs={rowLevelCTAs}
        onFilterShowClick={setOnFilterShow}
        onColumnShowClick={setOnColumnShow}
        currentRow={(data) => {
          setCurrentRowData(data);
        }}
        filters={
          <TransportReportFilter
            reportRef={reportRef}
            filters={(filters) => {
              setFilterStates(filters);
            }}
            onFilterShow={onFilterShow}
          />
        }
      />
      <TransportReportSummary
        refreshData={refreshData}
        refreshRef={refreshRef}
        showAutoComplete={() => {
          addTransport();
        }}
      />
      <Autocomplete
        show={showAddTransport}
        height="73%"
        width="80%"
        closeAutoComplete={closeTransportAc}
      >
        <AddTransport
          transportData={transportData}
          onEscape={closeTransportAc}
          onSaveTransport={closeTransportAc}
        />
      </Autocomplete>
    </div>
  );
};

export default Transport;
